var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIDescription = function SvgIDescription(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30078 10.9H11.7008M6.30078 14.5H9.00078M1.80078 2.8V17.2C1.80078 17.6774 1.99042 18.1352 2.32799 18.4728C2.66555 18.8104 3.12339 19 3.60078 19H14.4008C14.8782 19 15.336 18.8104 15.6736 18.4728C16.0111 18.1352 16.2008 17.6774 16.2008 17.2V6.7078C16.2008 6.468 16.1528 6.23063 16.0598 6.00962C15.9667 5.78861 15.8305 5.58842 15.659 5.4208L11.663 1.513C11.3267 1.18419 10.8751 1.00006 10.4048 1H3.60078C3.12339 1 2.66555 1.18964 2.32799 1.52721C1.99042 1.86477 1.80078 2.32261 1.80078 2.8Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8008 1V4.6C10.8008 5.07739 10.9904 5.53523 11.328 5.87279C11.6656 6.21036 12.1234 6.4 12.6008 6.4H16.2008",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIDescription);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/i-description.8d83f3c335c909a3f18165d67b3a7bda.svg";